export default {
  path: 'promotions',
  name: 'promotions',
  redirect: { name: 'promotions.index' },
  children: [
    {
      path: '',
      name: 'promotions.index',
      component: () => import('pages/promotions/IndexPage.vue'),
    },
    {
      path: 'create',
      name: 'promotions.create',
      component: () => import('pages/promotions/CreatePage.vue'),
    },
    {
      path: ':id',
      name: 'promotions.read',
      component: () => import('pages/promotions/ReadPage.vue'),
    },
    {
      path: 'update/:id',
      name: 'promotions.update',
      component: () => import('pages/promotions/CreatePage.vue'),
    },
  ],
}
